module.exports = __webpack_public_path__ + "img/wheelchair.e872e08c.png";